import { EntityType } from '@components'

import { TFunction } from 'i18next'
import { z } from 'zod'

import { DemoInvoiceSendAsEInvoiceFormSchema } from '../types/demoInvoiceSendAsEInvoiceFormSchema'

export const getDemoInvoiceSendAsEInvoiceFormSchema = (t: TFunction): DemoInvoiceSendAsEInvoiceFormSchema =>
  z.object({
    addressingLine: z
      .string()
      .trim()
      .min(1, { message: t('external_invoices.send_as_e_invoice.modal.field.addressing_line.error.required') }),
    companyName: z.string(),
    entityType: z.nativeEnum(EntityType).optional(),
  })
